import { Outlet } from 'react-router';
import { OfflineBanner } from '../components/Banners.tsx';
import { AppFooter, BottomNavigation } from '../components/layout/AppChrome.tsx';
import { AppHeader } from '../components/layout/AppHeader.tsx';

/**
 * Coquille de l'application. <main> est pleine largeur : l'accueil y place un hero bord à bord, les pages
 * internes s'enveloppent dans `.container` (PageContainer).
 */
export function Layout() {
  return (
    <div className="app">
      <a className="skip-link" href="#contenu">
        Aller au contenu
      </a>
      <AppHeader />
      <main className="app-main" id="contenu" tabIndex={-1}>
        <div className="container">
          <OfflineBanner />
        </div>
        <Outlet />
      </main>
      <AppFooter />
      <BottomNavigation />
    </div>
  );
}
